import { Component, OnDestroy, OnInit, Input } from "@angular/core"
import { ActivatedRoute, NavigationExtras, Params, Router } from "@angular/router"
import { Subscription } from "rxjs"
import { BrowsingService } from "../../../services/browsing.service"
import { LabeledValue } from "../../../utils/types"

@Component({
    selector: "app-rank-by",
    templateUrl: "./rank-by.component.html",
    styleUrls: ["./rank-by.component.scss"],
})
export class RankBy implements OnInit, OnDestroy {
    rankBy: string = "relevance"
    type: string = "search"
    subscriptions: Subscription[] = []

    // New
    public sortByOptions: Array<LabeledValue>
    public selectedOption

    @Input() public isOnSearch?: boolean = false

    constructor(
        private browsingService: BrowsingService,
        private route: ActivatedRoute,
        private router: Router
    ) {}

    ngOnInit() {
        this.sortByOptions = this.browsingService.sortByOptions
        this.subscriptions.push(
            this.route.queryParams.subscribe((queryParams: Params) => {
                if (queryParams.hasOwnProperty("rank_by")) {
                    this.rankBy = queryParams["rank_by"]
                } // default is relevance
                this.checkContext()
            })
        )
    }

    checkContext() {
        if (this.router.url.includes("search")) {
            this.type = "search"
        } else if (this.router.url.includes("subjects")) {
            this.type = "browse"
        } else if (this.router.url.includes("grades")) {
            this.type = "browse-by-grade"
        }
        const maybeSelectedOptionObject = this.sortByOptions.find(
            (opt) => opt.value === this.rankBy
        )
        if (maybeSelectedOptionObject) {
            this.selectedOption = maybeSelectedOptionObject.value
        } else {
            console.error("unknown sort option", this.rankBy)
        }
    }

    changeRanking($event, option: string) {
        this.rankBy = option
        let extras: NavigationExtras = {
            queryParams: { rank_by: this.rankBy },
            queryParamsHandling: "merge",
            relativeTo: this.route,
        }
        this.router.navigate(["."], extras)
    }

    ngOnDestroy() {
        this.subscriptions.map((subscription) => subscription.unsubscribe())
    }
}
